import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import api from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Sparkles } from 'lucide-react';

export default function AccountSelect() {
  const { user, setActiveAccountId, logout, loading } = useAuth();
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate('/login'); return; }
    if (user.role === 'owner') { navigate('/plannerapp'); return; }
    api.get('/auth/my-accounts').then(({ data }) => setAccounts(data)).catch(() => {});
  }, [user, loading]);

  const pick = (id) => { setActiveAccountId(id); navigate('/plannerapp'); };

  return (
    <div className="min-h-screen grid place-items-center pp-grad-hero px-4" style={{ background: '#07090A' }}>
      <div className="dark w-full max-w-lg text-center">
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-10 h-10 rounded-2xl grid place-items-center pp-glow-mint" style={{ background: 'rgba(62,180,137,0.15)' }}><Sparkles className="pp-mint" size={20} /></div>
          <span className="text-xl font-bold text-white">PlannerPRO</span>
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">Selecciona una cuenta</h1>
        <p className="text-sm text-[#A6C3B4] mb-8">Colaboras con estas cuentas. Elige con cuál trabajar.</p>
        {accounts.length === 0 && <p className="text-[#6b8479]">Aún no tienes cuentas asignadas.</p>}
        <div className="grid sm:grid-cols-2 gap-4">
          {accounts.map((a, i) => (
            <motion.button key={a.account_id} data-testid={`select-account-${a.account_id}`} onClick={() => pick(a.account_id)}
              initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}
              whileHover={{ scale: 1.03 }} className="pp-glass p-6 flex flex-col items-center gap-3">
              <Avatar className="w-16 h-16"><AvatarFallback className="text-2xl bg-[rgba(62,180,137,0.2)] pp-mint">{a.owner_name?.[0]}</AvatarFallback></Avatar>
              <div className="font-semibold text-white">{a.owner_name}</div>
              {a.expires_at && <div className="text-[10px] text-[#C9A84C]">Expira: {a.expires_at?.slice(0,10)}</div>}
            </motion.button>
          ))}
        </div>
        <button onClick={logout} className="mt-8 text-sm text-[#6b8479] hover:text-[#3EB489]">Cerrar sesión</button>
      </div>
    </div>
  );
}
